import fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchDatasetMetrics: ({ category, code }, readStatus) => fetch.useFetchDispatch(
    actions.FETCH_DATASET_METRICS,
    readStatus,
    { category, code },
    fetchConfig([category, code, readStatus]),
  ),
};
